import { RouteRecordRaw } from "vue-router";
import { useAuthStore } from "@/stores/auth";

export default {
  path: "/auth",
  meta: {
    onlyLoggedOut: true,
  },
  children: [
    {
      path: "login",
      name: "login",
      component: () => import("@/modules/auth/pages/LoginPage.vue"),
      meta: {
        authRequired: false,
      },
      beforeEnter() {
        const { resetState } = useAuthStore();
        resetState();
      },
    },
    {
      path: "register",
      name: "register",
      component: () => import("@/modules/auth/pages/RegisterPage.vue"),
    },
    {
      path: "verify-email",
      name: "verify-email",
      component: () => import("@/modules/auth/pages/VerifyEmail.vue"),
    },
    {
      path: "forgot-password",
      name: "forgot-password",
      component: () => import("@/modules/auth/pages/ForgotPassword.vue"),
    },
    {
      path: "confirm-password",
      name: "confirm-password",
      component: () => import("@/modules/auth/pages/ConfirmPassword.vue"),
    },
    {
      path: "reset-password",
      name: "reset-password",
      component: () => import("@/modules/auth/pages/ResetPassword.vue"),
    },
  ],
} as RouteRecordRaw;
